import { HiArrowLongRight } from "react-icons/hi2";
import ReactPlayer from "react-player";
import thumbail from "../../images/logo/logo_aqua.svg";
import img3 from "../../images/gemapi/gally/1.jpg";
import img2 from "../../images/gemapi/gally/2.jpg";
import img1 from "../../images/gemapi/gally/avr.-2017-travaux-berge-Chavenay-1024x614.jpg";

import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";
import "./carouselAnimation.css";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
} from "../ui/carousel";
import entretienimg from "../../images/entretien.jpg";
import IconsList4 from "./IconsList4";
import { Link } from "react-router-dom";

const GemapiRuDeGally = () => {
  const images = [
    { id: 1, img: img1 },
    { id: 2, img: img2 },
    { id: 3, img: img3 },
  ];

  const cards = [
    { id: 1, img: "🌾", title: "Fauchage", desc: "" },
    { id: 2, img: "🌳", title: "Élagage", desc: "" },
    {
      id: 4,
      img: "✂️",
      title: "Recépage",
      desc: "(taille à la base pour redonner vigueur)",
    },
    {
      id: 5,
      img: "🚫",
      title: "Gestion d’embâcles",
      desc: "(retrait des obstacles au flux)",
    },
    {
      id: 6,
      img: "🪤",
      title: "Piégeage",
      desc: "(retrait des obstacles au flux)",
    },
    { id: 7, img: "🌿", title: "Retrait des plantes invasives", desc: "" },
  ];

  return (
    <div>
      <div className="p-4 mt-10 sm:p-6 sm:mt-20 bg-secondary/10">
        <h1 className="text-xl font-bold text-center text-black">
          Un Peu d'Histoire
        </h1>
        <p className="mt-2 text-base text-center text-primary">
          Aux origines du ru de Gally : entre moulins et histoire royale
        </p>
      </div>

      <div className="container px-4 mx-auto mt-8 mb-10 sm:mt-10 sm:px-6 lg:px-8">
        <div className="grid items-center justify-center grid-cols-1 gap-6 mt-6 md:grid-cols-2 sm:mt-8">
          <div className="text-start">
            <h2 className="text-xl font-bold text-black">
              Du ru des Moulins de Galie au ru de Gally
            </h2>
            <p className="mt-2 text-base">
              Intimement lié au château de Versailles et à ses alentours, le ru
              de Gally prend sa source à proximité du grand canal. Affluent de
              la Mauldre, qui se jette pour sa part dans la Seine, ce ruisseau
              de 22 km de long s’appelait au XVIIe siècle le « ru des Moulins de
              Galie ». Les moulins qu’il alimentait étaient spécialisés
              principalement dans la farine, mais aussi le papier, et même le
              cachemire ! Au temps de Louis XIV, le cours d’eau était réputé
              pour ses truites et ses écrevisses.
            </p>
          </div>
          <div className="overflow-hidden rounded-lg w-[450px] h-[260px]">
            <ReactPlayer
              playing={false}
              url="https://www.youtube.com/watch?v=KStJ1AMftts"
              width="100%"
              height="100%"
            />
          </div>
        </div>
      </div>

      <IconsList4 headingTitle="" className="bg-white pt-7" />
      <div className="flex justify-center  ">
        <Link to="/gemapi/historique-ru-gally">
          <Button>Voir plus</Button>
        </Link>
      </div>

      <div className="p-4 mt-20 sm:p-6 sm:mt-20 bg-secondary/10">
        <h1 className="text-xl font-bold text-center text-black">
          Renaturation du Ru de Gally
        </h1>
        <p className="max-w-4xl mx-auto mt-4 text-base text-center sm:mt-6 text-primary">
          Le projet de renaturation du{" "}
          <span className="font-bold">ru de Gally</span> a fait l’objet d’une
          enquête publique en 2017. Approuvé par les riverains et aujourd’hui
          engagé, le projet a pour objectif de protéger les habitants des crues,
          de retrouver une biodiversité, de restaurer la qualité de l’eau et de
          revaloriser la fonction paysagère du ru.
        </p>
      </div>

      <div className="container px-4 mx-auto mt-8 mb-10 sm:mt-10 sm:px-6 lg:px-8">
        <div className="grid items-center justify-center grid-cols-1 gap-6 mt-6 md:grid-cols-2 sm:mt-8">
          <div className="text-start">
            <p className="mt-2 text-base">
              Les aménagements portent sur le tracé du lit (création de
              méandres), l’aménagement des berges et la recréation de la
              ripisylve (plantation d’une végétation aquatique diversifiée à
              vocation d’auto-épuration afin d’aider la rivière à pomper la
              pollution présente dans l’eau).
            </p>
          </div>
           
          <div className="overflow-hidden rounded-lg w-[450px] h-[260px]">
            <ReactPlayer
              playing={false}
              url="https://www.youtube.com/watch?v=q15Gf7B5FYc"
              width="100%"
              height="100%"
            />
          </div>
        </div>

        <div className="py-12 ">
          <div className="max-w-4xl px-4 mx-auto">
            <div className="flex flex-col justify-center gap-6 md:flex-row md:items-stretch">
              {/* Card 1: Maintien de l'écoulement */}
              <Link to={"/gemapi/ruisseau-naturelle"}>
                <div className="flex flex-col flex-1 p-6 bg-white border border-gray-200 rounded-lg shadow-lg hover:bg-secondary/10">
                  <div className="mx-auto mb-4 text-3xl text-center">🏞️</div>
                  <h3 className="mb-2 text-lg font-semibold text-center text-black min-h-[3rem] flex items-center justify-center whitespace-nowrap">
                    Renaturer le ruisseau
                  </h3>

                  <ul className="flex-grow mt-5 text-xs font-semibold list-disc whitespace-nowrap">
                    <li>Restauration de l'écosystème</li>
                    <li className="mt-5">
                      Retour de la biodiversité{" "}
                      <span className="text-neutral-500">
                        (poissons et autres espèces)
                      </span>
                    </li>
                    <li className="mt-5">Réduction du risque d'inondation</li>
                  </ul>
                  <div className="flex flex-row items-center justify-end mt-5 space-x-2">
                    <div className="text-sm text-primary ">Lire plus</div>
                    <div>
                      <HiArrowLongRight className="text-primary " />
                    </div>
                  </div>
                </div>
              </Link>
              {/* Card 2: Protection du sol et des nappes */}
              <Link to={"/gemapi/renaturer-le-ruisseau"}>
                <div className="flex flex-col flex-1 p-6 bg-white border border-gray-200 rounded-lg shadow-lg hover:bg-secondary/10">
                  <div className="mx-auto mb-4 text-3xl text-center">🌱</div>
                  <h3 className="mb-2 text-lg font-semibold text-center text-black min-h-[3rem] flex items-center justify-center whitespace-nowrap">
                    Végétaliser les berges
                  </h3>
                  <ul className="flex-grow mt-5 text-xs font-semibold list-disc whitespace-nowrap">
                    <li>Réduire la pollution</li>
                    <li className="mt-5">Restaurer la végétation</li>
                    <li className="mt-5">
                      Revitaliser les habitats naturels du ru de Gally.
                    </li>
                  </ul>
                  <div className="flex flex-row items-center justify-end mt-5 space-x-2">
                    <div className="text-sm text-primary ">Lire plus</div>
                    <div>
                      <HiArrowLongRight className="text-primary " />
                    </div>
                  </div>
                </div>
              </Link>
              {/* Card 3: Prévention des affaissements */}
              <Link to={"/gemapi/paysage-attractif"}>
                <div className="flex flex-col flex-1 p-6 bg-white border border-gray-200 rounded-lg shadow-lg hover:bg-secondary/10 whitespace-nowrap">
                  <div className="mx-auto mb-4 text-3xl text-center">🌿</div>
                  <h3 className="mb-2 text-lg font-semibold text-center text-black min-h-[3rem] flex items-center justify-center">
                    Rendre le paysage attractif
                  </h3>
                  <ul className="flex-grow mt-5 text-xs font-semibold list-disc whitespace-nowrap">
                    <li>Création de chemins de randonnée</li>
                    <li className="mt-5">Aménagement de balades équestres</li>
                    <li className="mt-5">Mise en valeur paysagère du ru </li>
                  </ul>
                  <div className="flex flex-row items-center justify-end mt-5 space-x-2">
                    <div className="text-sm text-primary ">Lire plus</div>
                    <div>
                      <HiArrowLongRight className="text-primary " />
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="p-4 mt-8 sm:p-6 sm:mt-10 bg-secondary/10">
        <h1 className="text-xl font-bold text-center text-black">
          Aménager et entretenir
        </h1>
        <p className="max-w-4xl mx-auto mt-4 text-base text-center sm:mt-6 text-primary">
          Le cours d’eau est un milieu naturel qu’il faut entretenir et
          protéger. Outre les travaux de renaturation,{" "}
          <span className="font-bold">HYDREAULYS</span> s’occupe de l’entretien
          du
          <span className="font-bold"> ru de Gally</span> toute l’année. Cela
          passe par l’enlèvement des déchets et dépôts flottants qui empêchent
          le bon écoulement de l’eau, par le fauchage et la taille de la
          végétation ainsi que par l’implantation de nouveaux végétaux.
        </p>
      </div>

      <div className="container px-4 mx-auto mt-8 mb-10 sm:mt-10 sm:px-6 lg:px-8">
        <div className="grid items-center justify-center grid-cols-1 gap-6 mt-6 md:grid-cols-2 sm:mt-8">
          <div className="text-start">
            <h2 className="text-xl font-bold text-black">
                Protéger les berges
            </h2>
            <p className="mt-2 text-base">
            HYDREAULYS utilise des techniques végétales pour protéger les berges du ru de Gally : des végétaux sont utilisés pour limiter leur érosion, les stabiliser et régénérer les sols.
            Ces techniques naturelles présentent de nombreux avantages : elles sont écologiques, esthétiques et peu onéreuses.
            </p>
          </div>
          <div className="flex justify-center">
            <div className="w-full max-w-6xl px-4 mx-auto">
              <Carousel
                opts={{ align: "start", loop: true }}
                className="w-full"
              >
                <CarouselContent>
                  {images.map((item) => (
                    <CarouselItem key={item.id}>
                      <div className="flex items-center justify-center w-full h-64 bg-gray-200 rounded-lg sm:h-80 md:h-96">
                        <img
                          src={item.img}
                          alt="Ru de Gally maintenance"
                          className="object-cover w-full h-full rounded-lg"
                        />
                      </div>
                    </CarouselItem>
                  ))}
                </CarouselContent>
                <CarouselPrevious className="absolute flex items-center justify-center border-none text-white transform -translate-y-1/2 bg-teal-500 rounded-full   left-2 sm:left-4 top-1/2 hover:bg-teal-600" />
                <CarouselNext className="absolute flex items-center justify-center border-none text-white transform -translate-y-1/2 bg-teal-500 rounded-full   right-2 sm:right-4 top-1/2 hover:bg-teal-600" />
              </Carousel>
            </div>
          </div>
        </div>
      </div>

      <div className="container px-4 mx-auto mt-8 mb-10 sm:mt-10 sm:px-6 lg:px-8">
        <div className="grid items-center justify-center grid-cols-1 gap-6 mt-6 md:grid-cols-2 sm:mt-8">
          <div className="text-start">
            <h2 className="text-xl font-bold text-black">
              Maintenir la capacité d’écoulement
            </h2>
            <p className="mt-2 text-base">
              Chaque année, les opérations qu’{" "}
              <span className="font-bold text-primary">HYDREAULYS</span> est
              amené à réaliser sont multiples :
            </p>
          </div>
        </div>
      </div>

      <div className="slider">
        <div className="flex flex-row space-x-4 slide-track">
          {[...cards, ...cards].map((slide, index) => (
            <div
              key={`${slide.id}-${index}`}
              className="flex-none pl-2 slide md:pl-4"
            >
              <Card className="bg-primary/10 border-0 shadow-sm min-w-[280px] h-full">
                <CardContent className="p-6">
                  <div className="flex flex-col items-start h-full">
                    <div className="mb-4 text-4xl text-left">{slide.img}</div>
                    <h3 className="mb-2 text-lg font-bold text-left text-black">
                      {slide.title}
                    </h3>
                    {slide.desc && (
                      <p className="text-sm leading-relaxed text-left text-gray-600">
                        {slide.desc}
                      </p>
                    )}
                  </div>
                </CardContent>
              </Card>
            </div>
          ))}
        </div>
      </div>

      <div className="p-4 mt-8 sm:p-6 sm:mt-20 bg-secondary/10">
        <h1 className="text-xl font-bold text-center text-black">
          Prévenir les inondations
        </h1>
        <p className="max-w-4xl mx-auto mt-4 text-base text-center sm:mt-6 text-primary">
          Le <span className="font-bold">ru de Gally</span> est soumis à un Plan
          de Prévention du Risque Inondation (PPRI) qui définit les aléas et les
          règles de construction à suivre dans les zones inondables.
        </p>
      </div>

      <div className="container px-4 mx-auto mt-8 mb-10 sm:mt-10 sm:px-6 lg:px-8">
        <div className="grid items-center justify-center grid-cols-1 gap-6 mt-6 md:grid-cols-2 sm:mt-8">
          <div className="text-start">
            <p className="mt-2 text-base">
              La forte urbanisation des décennies précédentes ayant profondément
              modifié l’environnement du ru, de nombreuses inondations avaient
              été provoquées dans les années 1960. Des travaux de rectifications
              du lit et la création du bassin de rétention des eaux pluviales de
              Rennemoulin s’en sont suivies. Depuis 2001, aucune crue marquante
              n’a été recensée. <br />
              <span className="font-bold">Un entretien régulier</span> est, de
              plus, assuré par le SMAERG afin de maintenir une bonne capacité
              d’écoulement du ruisseau.
            </p>
          </div>
          <div className="flex justify-center">
            <img
              src={entretienimg}
              alt="Flood prevention efforts"
              className="w-full h-auto max-w-xs rounded-lg sm:max-w-sm"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GemapiRuDeGally;
